var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-fill text-green font-bold p-3 text-center"},[(_vm.meta.trade == 'BUY')?_c('span',[_vm._v("\n\t\t"+_vm._s(_vm.__(
				"Bids are binding until the end of their validity. A contract is concluded with confirmation from the seller."
			))+"\n\t")]):_c('span',[_vm._v("\n\t\t"+_vm._s(_vm.__(
				"Offers are binding until the end of their validity. A contract is concluded with confirmation from the buyer."
			))+"\n\t")]),_vm._v("\n\t"+_vm._s(_vm.__("messages.entering_contract", { args: { par: _vm.cropFeeEstimate } }))+"\n\t")])
}
var staticRenderFns = []

export { render, staticRenderFns }